module.exports = __webpack_public_path__ + "static/img/authority.385b3fc7.jpg";